if (!customElements.get('collection-products')) {
  customElements.define('collection-products',
    class CollectionProducts extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        this.initializeBlazeSlider();
      }
    
      // Método para inicializar o Blaze Slider
      initializeBlazeSlider() {
        const blazeSlider = this.querySelector('.collection-products__slider');
        
        if (!blazeSlider) return;

        const slider = new BlazeSlider(blazeSlider, {
          all: {
            transitionDuration: 300,
            transitionTimingFunction: 'cubic-bezier(0.45, 0.1, 0.45, 0.5)',
            slidesToShow: 1.6,
            slidesToScroll: 1,
            slideGap: 'clamp(1.6rem, 1.66667vw, 3.2rem)',
            loop: false,
            enableAutoplay: false,
          },
          '(min-width: 768px)': {
            slidesToShow: 2,
          },
          '(min-width: 1024px)': {
            slidesToShow: 3,
          },
          '(min-width: 1440px)': {
            slidesToShow: 4,
          },
        });

        // Opcional: adicionar navegação customizada se necessário
        const prevBtn = this.querySelector('.blaze-prev');
        const nextBtn = this.querySelector('.blaze-next');
        
        if (prevBtn) {
          prevBtn.addEventListener('click', () => slider.prev());
        }
        
        if (nextBtn) {
          nextBtn.addEventListener('click', () => slider.next());
        }
      }
    }
  );
}